import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getGlobalSearchCourses,
  getGlobalSearchCoursesClear,
} from "../../redux/courses/actions";
import {
  convertMinutesToHoursAndMinutes,
  convertSecondsToMins,
  convertTimeFormat,
  convertTimeInHourAndMin,
  getPriceInfoForEntity,
  getProcureInfo,
  goToLPDetailUtil,
  ProductCardPriceInfo,
  redirectToPageUtil,
  SessionKeys,
} from "../../utils/AppUtils";
import Loader from "../Loader/Loader";
import useLogin from "../../custom-hooks/useLogin";
import {
  getGlobalSearchVideos,
  getGlobalSearchVideosClear,
} from "../../redux/video/actions";
import {
  getGlobalSearchEvents,
  getGlobalSearchEventsClear,
} from "../../redux/events/actions";
import {
  getGlobalSearchLP,
  getGlobalSearchLPClear,
} from "../../redux/learningPath/actions";
import ErrorSection from "../ErrorPage/ErrorSection";
import {
  getGlobalSearchCoaching,
  getGlobalSearchCoachingClear,
  getGlobalSearchPartners,
  getGlobalSearchPartnersClear,
} from "../../redux/provider/actions";
import {
  getGlobalSearchCertificates,
  getGlobalSearchCertificatesClear,
} from "../../redux/certificateURL/actions";
import CommonComponentEntity from "../NewDesign/UsefulEntity/CommonComponentEntity";
import { faL } from "@fortawesome/free-solid-svg-icons";

const SearchSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);

  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const authBroker = useSelector((state) => state.auth.authBroker);

  const [searchWord, setSearchWord] = useState(params.get("keyword"));
  const [searchInput, setSearchInput] = useState(params.get("keyword"));
  const [searchLookup, setSearchLookup] = useState(false);

  const [courseAvailable, setCourseAvailable] = useState(false);
  const [lpAvailable, setLpAvailable] = useState(false);
  const [partnersAvailable, setPartnersAvailable] = useState(false);
  const [coachingAvailable, setCoachingAvailable] = useState(false);
  const [eventAvailable, setEventAvailable] = useState(false);
  const [videoAvailable, setVideoAvailable] = useState(false);
  const [certifyAvailable, setCertifyAvailable] = useState(false);
  const [isNoData, setIsNoData] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [isPartnerLoading, setIsPartnerLoading] = useState(false);
  const [isCoachingLoading, setIsCoachingLoading] = useState(false);
  const [isLpLoading, setIsLpLoading] = useState(false);
  const [isEventLoading, setIsEventLoading] = useState(false);
  const [isCertifyLoading, setIsCertifyLoading] = useState(false);
  const sortByAlphabetical = (list) => {
    return list.sort((a, b) =>
      b.published_date.localeCompare(a.published_date)
    );
  };
  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [dispatch]);

  useEffect(() => {
    if (
      params.get("keyword") &&
      params.get("keyword") !== "" &&
      params.get("keyword") !== "null"
    ) {
      setSearchWord(params.get("keyword"));
      setSearchInput(params.get("keyword"));
    } else {
    }
  }, [params.get("keyword")]);

  const getCoursesData = () => {
    dispatch(
      getGlobalSearchCourses({
        module: "gsCourses",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            : "",
          search: searchInput,
        },
      })
    );
  };

  const getVideosData = () => {
    dispatch(
      getGlobalSearchVideos({
        module: "gsVideos",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            : "",
          search: searchInput,
        },
      })
    );
  };

  const getEventsData = () => {
    dispatch(
      getGlobalSearchEvents({
        module: "gsEvents",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            : "",
          search: searchInput,
        },
      })
    );
  };

  const getLPData = () => {
    dispatch(
      getGlobalSearchLP({
        module: "gsLp",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            : "",
          search: searchInput,
        },
      })
    );
  };

  const getPartnersData = () => {
    dispatch(
      getGlobalSearchPartners({
        module: "gsPartners",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            : "",
          search: searchInput,
        },
      })
    );
  };

  const getCoachingData = () => {
    dispatch(
      getGlobalSearchCoaching({
        module: "gsCoachings",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            : "",
          search: searchInput,
        },
      })
    );
  };

  const getCertificatesData = () => {
    dispatch(
      getGlobalSearchCertificates({
        module: "gsCertificates",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            : "",
          search: searchInput,
        },
      })
    );
  };

  useEffect(() => {
    if (searchWord && searchWord !== "" && searchWord !== "null") {
      setSearchLookup(true);
      setIsLoading(true);
      setIsCertifyLoading(true);
      setIsCoachingLoading(true);
      setIsEventLoading(true);
      setIsLpLoading(true);
      // setIsPartnerLoading(true);
      setIsVideoLoading(true);

      getCoursesData();
      getVideosData();
      getEventsData();
      getLPData();
      // getPartnersData();
      getCoachingData();
      getCertificatesData();
    }
    return () => {
      dispatch(getGlobalSearchCoursesClear());
      dispatch(getGlobalSearchVideosClear());
      dispatch(getGlobalSearchEventsClear());
      dispatch(getGlobalSearchLPClear());
      dispatch(getGlobalSearchPartnersClear());
      dispatch(getGlobalSearchCoachingClear());
      dispatch(getGlobalSearchCertificatesClear());
      setCourseAvailable(false);
      setVideoAvailable(false);
      setEventAvailable(false);
      setPartnersAvailable(false);
      setCoachingAvailable(false);
      setCertifyAvailable(false);
      setLpAvailable(false);
    };
  }, [searchWord]);

  const navigateToView = (video) => {
    let paramsReq = {
      code: video?.course_code,
      source: _.lowerCase(video?.source),
      is_paid: video?.priceInfo.isFree,
    };
    if (!_.isEmpty(video.categoryId)) {
      paramsReq.catId = video?.categoryId[0];
    }
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    // let url = `/video-view-page/${video?.product_id}/?source=${_.lowerCase(
    //   video?.source
    // )}&code=${video?.course_code}&is_paid=${video?.priceInfo.isFree}`;
    // if (!_.isEmpty(video.categoryId)) {
    //   url += `&catId=${video?.categoryId[0]}`;
    // }
    let url = `/video-view-page/${video?.product_id}/?c=${encodedUrl}`;
    navigate(url);
  };

  const globalSearchCoursesResponse = useSelector(
    (state) => state.courses.globalSearchCourses
  );

  const globalSearchVideosResponse = useSelector(
    (state) => state.video.globalSearchVideos
  );

  const globalSearchCoachingResponse = useSelector(
    (state) => state.provider.globalSearchCoaching
  );

  const globalSearchPartnersResponse = useSelector(
    (state) => state.provider.globalSearchPartners
  );

  const globalSearchEventsResponse = useSelector(
    (state) => state.events.globalSearchEvents
  );

  const globalSearchLPResponse = useSelector(
    (state) => state.learningPath.globalSearchLP
  );

  const globalSearchCertificatesResponse = useSelector(
    (state) => state.certificateURL.globalSearchCertificates
  );

  const [coursesData, setCoursesData] = useState([]);
  const [videosData, setVideosData] = useState([]);
  const [coachingsData, setCoachingsData] = useState([]);
  const [partnersData, setPartnersData] = useState([]);
  const [eventsData, setEventsData] = useState([]);
  const [certificatesData, setCertificatesData] = useState([]);
  const [lpData, setLpData] = useState([]);
  const [courseData, setCourseData] = useState([]);

  const { isLoggedIn } = useLogin();

  const navigateToCoachingView = (data) => {
    let paramsReq = {
      service_code: data?.service_code,
      service_id: data?.product_id,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    let url = `/coaching-detail?c=${encodedUrl}`;
    navigate(url);
  };

  const navigateToEvents = (data) => {
    let paramsReq = {
      event_id: data.event_id,
      event_code: data?.event_code,
      source: data.source,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);

    let url = `/event-detail?c=${encodedUrl}`;
    navigate(url);
  };

  const formatProductCardData = (coursesList) => {
    let prodArr = [];
    for (let course of coursesList) {
      let tags = [];
      let btnTitle = "Start course";
      if (course?.provider) {
        tags.push(course?.provider?.provider_display_name);
      }
      tags.push("Course");

      tags.push(`${course?.lessons} Module${course?.lessons > 1 ? "s" : ""}`);

      if (course?.duration) {
        tags.push(convertTimeFormat(course.duration, true));
      }

      if (course?.crs_progress > 0 && course?.crs_progress < 100) {
        btnTitle = "Resume course";
      } else if (course?.crs_progress >= 100) {
        btnTitle = "Revisit course";
      }

      let priceInfo = getProcureInfo(course?.purchased_info);
      course.priceInfo = priceInfo;
      course.isLoggedIn = isLoggedIn;

      let updatedAt =
        _.isEmpty(priceInfo) || priceInfo?.isFree || !priceInfo.isPurchased
          ? course?.created_dt
          : "";

      prodArr.push({
        id: course?.id,
        is_like: course?.is_like ? course?.is_like : false,
        is_bookmark: course?.is_bookmark ? course?.is_bookmark : false,
        dbId: course?.list_id,
        productType: "course",
        productOrigin: course?.origin,
        title: course.name,
        logoURL: course.provider?.provider_img
          ? course.provider?.provider_img
          : "",
        bannerURL: course.imageURL,
        tagsArray: tags,
        description: course.short_description,
        btnTitle: btnTitle,
        progress: course.crs_progress,
        showLikeMenu: true,
        btnAction: () =>
          redirectToPageUtil(
            course,
            navigate,
            authBroker,
            setCourseData,
            dispatch
          ),
        descAction: {},
        bannerAction: () =>
          redirectToPageUtil(
            course,
            navigate,
            authBroker,
            setCourseData,
            dispatch
          ),
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        showHeader: true,
        showProviderIcon: true,
        showBody: course.short_description ? true : false,
        showFooter: true,
        showProgress: _.toNumber(course.crs_progress) > 0 ? true : false,
        cardClassName: "",
        rightBtnIcon: "/images/arrow-right.svg",
        updatedAt: course?.created_dt,
        leftBtnIcon: "",
        isLoading: false,
        updatedAt: updatedAt,
        priceInfo,
        isUpdated: course?.module_updated,
      });
    }
    setCoursesData(prodArr);
  };

  const formatProductCardDataForVideos = async (videoList) => {
    let videoArr = [];

    for (let video of videoList) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";
      if (!_.isEmpty(video.provider)) {
        tags.push(video.provider.display_name);
        logoURL = video.provider.provider_img;
      }
      tags.push("Video");
      tags.push(`${video.views} View${video.views > 1 ? "s" : ""}`);
      if (video.course_duration) {
        const duration = convertTimeFormat(video.course_duration, true);
        tags.push(`${duration}`);
      }

      let priceInfo = getProcureInfo(video.purchased_info);
      video.priceInfo = priceInfo;

      videoArr.push({
        id: video?.product_id,
        is_like: video?.is_like ? video?.is_like : false,
        is_bookmark: video?.is_bookmark ? video?.is_bookmark : false,
        dbId: video?.list_id,
        productType: "video",
        productOrigin: video?.origin,
        title: video.product_name,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: video.product_thumbnail,
        tagsArray: tags,
        description: video.long_description,
        duration: convertTimeFormat(video.course_duration, true),
        showHeader: true,
        showProviderIcon: true,
        showLikeMenu: true,
        showPlayButton: true,
        showProgress: false,
        showBody: false,
        showFooter: true,
        btnTitle: btnTitle,
        btnAction: () => navigateToView(video),
        descAction: () => {},
        bannerAction: () => navigateToView(video),
        cardClassName: "",
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        isLoading: false,
        view: video.views,
        priceInfo: priceInfo,
        rightBtnIcon: "/images/arrow-right.svg",
        leftBtnIcon: "",
        updatedAt: video?.created_dt,
      });
    }
    setVideosData(videoArr);
  };

  const formatProductCardDataForEvents = (events) => {
    let eventArr = [];

    for (let item of events) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";

      let footerComp = "";

      eventArr.push({
        id: item?.event_id,
        is_like: item?.is_like ? item?.is_like : false,
        is_bookmark: item?.is_bookmark ? item?.is_bookmark : false,
        dbId: item?.list_id,
        productType: item?.type,
        productOrigin: item?.source,
        title: item.title,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: item.thumbnail,
        tagsArray: tags,
        description: item.description,
        duration: convertTimeInHourAndMin(item.duration ? item.duration : 0),
        showHeader: true,
        showProviderIcon: false,
        showLikeMenu: true,
        showPlayButton: false,
        showProgress: false,
        showBody: true,
        showFooter: true,
        btnTitle: btnTitle,
        btnAction: () => navigateToEvents(item),
        descAction: () => {},
        bannerAction: (e) => navigateToEvents(item),
        cardClassName: "",
        footerLineComp: footerComp,
        isLoading: false,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
      });
    }
    setEventsData(eventArr);
  };

  const goToLPDetail = (lpInfo) => {
    let paramsReq = {
      lp_id: lpInfo.id,
      is_level: "false",
      source: lpInfo?.origin,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    navigate(`/lpDetail?c=${encodedUrl}`);
  };

  const formatProductCardDataForLP = (lpData) => {
    let lpArr = [];

    for (let lp of lpData) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";
      if (!_.isEmpty(lp.provider)) {
        tags.push(lp.provider.display_name);
        logoURL = lp.provider.provider_img;
      }
      tags.push("Learning Path");

      if (lp.course_count) {
        tags.push(`${lp.course_count} Course${lp.course_count > 1 ? "s" : ""}`);
      }
      if (lp.video_count) {
        tags.push(`${lp.video_count} Video${lp.video_count > 1 ? "s" : ""}`);
      }
      if (lp.level_count) {
        tags.push(`${lp.level_count} Level${lp.level_count > 1 ? "s" : ""}`);
      }
      if (lp.event_count) {
        tags.push(`${lp.event_count} Event${lp.event_count > 1 ? "s" : ""}`);
      }
      if (lp.duration) {
        tags.push(convertTimeFormat(lp.duration, true));
      }
      let priceInfo = getProcureInfo(lp.purchased_info);
      lp.priceInfo = priceInfo;

      lpArr.push({
        id: lp?.id,
        is_like: lp?.is_like ? lp?.is_like : false,
        is_bookmark: lp?.is_bookmark ? lp?.is_bookmark : false,
        dbId: lp?.list_id,
        productType: "learningpath",
        productOrigin: lp?.origin,
        title: lp.name,
        logoURL: logoURL,
        logoAlText: "LP",
        bannerURL: lp.thumbnail,
        tagsArray: tags,
        description: lp.description,
        duration: "",
        showHeader: true,
        showProviderIcon: true,
        showLikeMenu: true,
        showPlayButton: false,
        showProgress: true,
        showBody: false,
        showFooter: true,
        progress: lp.learn_progress,
        btnTitle: btnTitle,
        btnAction: () => goToLPDetailUtil(lp, navigate),
        descAction: () => {},
        bannerAction: () => goToLPDetailUtil(lp, navigate),
        cardClassName: "",
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        isLoading: false,
        priceInfo: "",
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
      });
    }
    setLpData(lpArr);
  };

  const navigateToCertificates = (data) => {
    let paramsReq = {
      event_id: data.event_id,
      event_code: data?.event_code,
      source: data.source,
      fromCert: "true",
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);

    let url = `/event-detail?c=${encodedUrl}`;
    // let url = `/event-detail?event_id=${data.event_id}`;
    // url = url + `&event_code=${data?.event_code}` + `&source=${data.source}`;
    navigate(url);
  };
  const formatProductCardDataForCertificates = (certificatList) => {
    let certificationArr = [];

    for (let item of certificatList) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";

      let priceInfo = getPriceInfoForEntity({
        isUserPremiun: isPremiumUser,
        productType: item.product_type ? item.product_type.toLowerCase() : "",
        premiumPrice: item.product_premium_price
          ? item.product_premium_price
          : 0,
        basicPrice: item.product_basic_price ? item.product_basic_price : 0,
        offerPremiumPrice: 0,
        offerBasicPrice: 0,
        offerStartDate: "", //video.start_date_&_time_of_offer,
        offerEndDate: "", //video.end_date_&_time_of_offer,
        source: item.source,
        productIsPaid: false,
        inAddToCart: false,
      });

      let footerComp = "";

      certificationArr.push({
        id: item?.event_id,
        dbId: item?.list_id,
        is_like: item?.is_like ? item?.is_like : false,
        is_bookmark: item?.is_bookmark ? item?.is_bookmark : false,
        productType: item?.type,
        productOrigin: item?.source,
        title: item.title,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: item.thumbnail,
        tagsArray: tags,
        description: item.description,
        duration: convertTimeInHourAndMin(item.duration ? item.duration : 0),
        showHeader: true,
        showProviderIcon: false,
        showLikeMenu: true,
        showPlayButton: false,
        showProgress: false,
        showBody: true,
        showFooter: true,
        btnTitle: btnTitle,
        btnAction: () => navigateToCertificates(item),
        descAction: () => {},
        bannerAction: (e) => navigateToCertificates(item),
        cardClassName: "",
        footerLineComp: footerComp,
        isLoading: false,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
      });
    }
    setCertificatesData(certificationArr);
  };

  const navigateToPartner = (data) => {
    let paramsReq = {
      provider_id: data?.provider_id,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    let url = `/partner-detail/?c=${encodedUrl}`;
    navigate(url);
  };

  const formatProductCardDataForPartners = (partnersList) => {
    let eventArr = [];
    for (let item of partnersList) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";
      logoURL = item.provider_img;

      let footerComp = "";

      eventArr.push({
        id: item?.provider_id,
        is_like: item?.is_like ? item?.is_like : false,
        is_bookmark: item?.is_bookmark ? item?.is_bookmark : false,
        dbId: item?.list_id,
        productType: "partner",
        productOrigin: "xsel",
        title: item.provider_name,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: item.thumbnail,
        tagsArray: tags,
        description: item.description ? item.description : "",
        duration: convertTimeInHourAndMin(item.duration ? item.duration : 0),
        showHeader: true,
        showPlayButton: false,
        showProviderIcon: false,
        showLikeMenu: true,
        showProgress: false,
        showBody: true,
        showFooter: true,
        btnTitle: btnTitle,
        btnAction: () => navigateToPartner(item),
        descAction: () => {},
        bannerAction: (e) => navigateToPartner(item),
        cardClassName: "",
        footerLineComp: footerComp,
        isLoading: false,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
      });
    }
    setPartnersData(eventArr);
  };

  const formatProductCardDataForCoaching = (coachingData) => {
    let eventArr = [];
    for (let item of coachingData) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";
      logoURL = item.provider.provider_img;
      // for (let i of item.menu_data) {
      //     tags.push(i);
      // }
      tags.push(item.provider.provider_display_name);
      tags.push("Services"); //item.service_type
      tags.push(
        _.toLower(item?.payment_frequency) === "monthly"
          ? "Subscription"
          : "One Time"
      );
      let priceInfo = getProcureInfo(item.purchased_info);
      eventArr.push({
        id: item?.product_id,
        is_like: item?.is_like ? item?.is_like : false,
        is_bookmark: item?.is_bookmark ? item?.is_bookmark : false,
        is_wishlist: item?.is_addtowishlist,
        dbId: item?.list_id,
        is_coaching: true,
        show_subscription:
          _.toLower(item?.payment_frequency) === "monthly" ? true : false,
        productType: item?.service_type,
        productOrigin: item?.source,
        title: item.product_name,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: item.product_thumbnail,
        tagsArray: tags,
        description: item.summary ? item.summary : "",
        duration: convertTimeInHourAndMin(item.duration ? item.duration : 0),
        showHeader: true,
        showPlayButton: false,
        showProviderIcon: true,
        showLikeMenu: true,
        showProgress: false,
        showBody: false,
        showFooter: true,
        btnTitle: btnTitle,
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        btnAction: () => navigateToCoachingView(item),
        descAction: () => {},
        bannerAction: (e) => navigateToCoachingView(item),
        cardClassName: "",
        isLoading: false,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
        priceInfo,
        updatedAt:
          _.isEmpty(priceInfo) || !priceInfo.isPurchased
            ? item?.created_dt
            : "",
      });
    }
    setCoachingsData(eventArr);
  };

  useEffect(() => {
    console.log("gs--", globalSearchCoursesResponse);
    if (!_.isEmpty(globalSearchCoursesResponse)) {
      if (globalSearchCoursesResponse?.status === "success") {
        let coursesList =
          globalSearchCoursesResponse?.payload?.payload?.courseList;
        if (coursesList != null && coursesList.length > 0) {
          setCourseAvailable(true);
          formatProductCardData(coursesList);
        }

        setSearchLookup(false);
        setIsLoading(false);
      } else {
        setCoursesData([]);
        setSearchLookup(false);
        setIsLoading(false);
      }
    }
  }, [globalSearchCoursesResponse]);

  useEffect(() => {
    console.log("gs--", globalSearchVideosResponse);
    if (!_.isEmpty(globalSearchVideosResponse)) {
      if (globalSearchVideosResponse?.status === "success") {
        const list1 = globalSearchVideosResponse?.payload?.payload?.videoList;
        if (list1 != null && list1.length > 0) {
          setVideoAvailable(true);
          formatProductCardDataForVideos(list1);
        }

        setSearchLookup(false);
        setIsVideoLoading(false);
      } else {
        setVideosData([]);
        setSearchLookup(false);
        setIsVideoLoading(false);
      }
    }
  }, [globalSearchVideosResponse]);

  useEffect(() => {
    console.log("gs--", globalSearchEventsResponse);
    if (!_.isEmpty(globalSearchEventsResponse)) {
      if (globalSearchEventsResponse?.status === "success") {
        const list1 = globalSearchEventsResponse?.payload?.payload?.records;
        if (list1 != null && list1.length > 0) {
          setEventAvailable(true);
          formatProductCardDataForEvents(list1);
        }

        setSearchLookup(false);
        setIsEventLoading(false);
      } else {
        setEventsData([]);
        setSearchLookup(false);

        setIsEventLoading(false);
      }
    }
  }, [globalSearchEventsResponse]);

  useEffect(() => {
    console.log("gs--", globalSearchLPResponse);
    if (!_.isEmpty(globalSearchLPResponse)) {
      if (globalSearchLPResponse?.status === "success") {
        const list1 = globalSearchLPResponse?.payload?.payload?.records;
        if (list1 != null && list1.length > 0) {
          setLpAvailable(true);
          formatProductCardDataForLP(list1);
        }

        setSearchLookup(false);
        setIsLpLoading(false);
      } else {
        setLpData([]);
        setSearchLookup(false);
        setIsLpLoading(false);
      }
    }
  }, [globalSearchLPResponse]);

  useEffect(() => {
    console.log("gs--", globalSearchCertificatesResponse);
    if (!_.isEmpty(globalSearchCertificatesResponse)) {
      if (globalSearchCertificatesResponse?.status === "success") {
        const list1 =
          globalSearchCertificatesResponse?.payload?.payload
            ?.event_certificateList;
        if (list1 != null && list1.length > 0) {
          setCertifyAvailable(true);
          formatProductCardDataForCertificates(list1);
        }

        setSearchLookup(false);
        setIsCertifyLoading(false);
      } else {
        setCertificatesData([]);
        setSearchLookup(false);

        setIsCertifyLoading(false);
      }
    }
  }, [globalSearchCertificatesResponse]);

  useEffect(() => {
    console.log("gs--", globalSearchPartnersResponse);
    if (!_.isEmpty(globalSearchPartnersResponse)) {
      if (globalSearchPartnersResponse?.status === "success") {
        const list1 =
          globalSearchPartnersResponse?.payload?.payload?.providerList;
        if (list1 != null && list1.length > 0) {
          setPartnersAvailable(true);
          formatProductCardDataForPartners(list1);
        }

        setSearchLookup(false);
        setIsPartnerLoading(false);
      } else {
        setPartnersData([]);
        setSearchLookup(false);

        setIsPartnerLoading(false);
      }
    }
  }, [globalSearchPartnersResponse]);

  useEffect(() => {
    console.log("gs--", globalSearchCoachingResponse);
    if (!_.isEmpty(globalSearchCoachingResponse)) {
      if (globalSearchCoachingResponse?.status === "success") {
        const list1 = globalSearchCoachingResponse?.payload?.payload?.List;
        if (list1 != null && list1.length > 0) {
          setCoachingAvailable(true);
          formatProductCardDataForCoaching(list1);
        }

        setSearchLookup(false);
        setIsCoachingLoading(false);
      } else {
        setPartnersData([]);
        setSearchLookup(false);
        setIsCoachingLoading(false);
      }
    }
  }, [globalSearchCoachingResponse]);

  const searchValue = () => {
    setErrorMsg("");
    if (searchInput === null || searchInput === "") {
      setErrorMsg("Please enter a search term.");
      setCourseAvailable(false);
      setCoursesData([]);
      setVideoAvailable(false);
      setVideosData([]);
      setEventAvailable(false);
      setEventsData([]);
      setCertifyAvailable(false);
      setCertificatesData([]);
      setLpAvailable(false);
      setLpData([]);
      setPartnersAvailable(false);
      setPartnersData([]);
      setCoachingAvailable(false);
      setCoachingsData([]);
      setSearchWord("");
      navigate("/search");
      return;
    }
    navigate(`/search?keyword=${searchInput}`);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      searchValue();
    }
  };

  return (
    <>
      <Loader
        start={
          isLoading ||
          isVideoLoading ||
          isEventLoading ||
          // isCertifyLoading ||
          // isCoachingLoading ||
          isLpLoading
          // ||
          // isPartnerLoading
        }
      />
      <section className="my-credit-points searchpage">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-md-12 col-sm-12 mb-5">
              <div className="search_heading profile-left-sec">
                <p className="lable-heading_search">
                  {searchLookup ? "Looking for Result of" : "Search Result for"}
                </p>
              </div>
              <div
                className={`sHeadg profile-left-sec ${
                  searchWord ? "" : "mt-3"
                }`}
              >
                {searchWord && <p className="sub_hedgf">‘{searchWord}’</p>}
              </div>
              <div className="search-sec-options">
                {/* <label htmlFor="search" className="input__label">
                  Search
                </label> */}
                <div className="input-text position-relative d-flex align-items-center">
                  <input
                    type="text"
                    id="search"
                    name="search"
                    className="input__field02"
                    placeholder="Search"
                    value={searchInput}
                    onKeyDown={handleKeyDown}
                    onChange={(e) => setSearchInput(e.target.value)}
                  />
                  <button
                    className={`button-reset ${
                      searchInput === null || searchInput === ""
                        ? "cursor-not-allowed"
                        : ""
                    }`}
                    onClick={() => {
                      searchValue();
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.16663 1.66669C5.02449 1.66669 1.66663 5.02455 1.66663 9.16669C1.66663 13.3088 5.02449 16.6667 9.16663 16.6667C10.9375 16.6667 12.565 16.053 13.848 15.0266L16.9107 18.0893C17.2361 18.4147 17.7638 18.4147 18.0892 18.0893C18.4147 17.7638 18.4147 17.2362 18.0892 16.9108L15.0265 13.8481C16.0529 12.565 16.6666 10.9375 16.6666 9.16669C16.6666 5.02455 13.3088 1.66669 9.16663 1.66669ZM3.33329 9.16669C3.33329 5.94503 5.94496 3.33335 9.16663 3.33335C12.3883 3.33335 15 5.94503 15 9.16669C15 12.3883 12.3883 15 9.16663 15C5.94496 15 3.33329 12.3883 3.33329 9.16669Z"
                        fill="black"
                      />
                    </svg>
                  </button>
                </div>
                <p className="error-msg">{errorMsg}</p>
              </div>
            </div>
          </div>
        </div>

        {!lpAvailable &&
        !videoAvailable &&
        !courseAvailable &&
        !eventAvailable &&
        !certifyAvailable &&
        !coachingAvailable &&
        !partnersAvailable ? (
          <div className="container">
            <ErrorSection
              btnTitle={"Explore Courses"}
              btnAction={"/learn/courses?tab=1"}
            />
          </div>
        ) : isLoading ? (
          // CONFIG.INITIAL_PRODUCT_CARD_DATA.map((video, i) => {
          //   if (i < 3) {
          //     return (
          //       <div className="row coursecard-row videosection-cont">
          //         <ProductCardComponent {...video} key={`video-${i + 1}`} />
          //       </div>
          //     );
          //   }
          // })
          ""
        ) : (
          <div>
            {courseAvailable ? (
              coursesData.length > 0 ? (
                <CommonComponentEntity
                  newCardData={coursesData}
                  heading={"Courses"}
                  subHeading={`👍🏻100+ learners have found these useful`}
                  viewAllAction={"/learn/courses?tab=1"}
                  type={"course"}
                />
              ) : (
                "No courses found"
              )
            ) : (
              ""
            )}

            {lpAvailable ? (
              lpData.length > 0 ? (
                <CommonComponentEntity
                  newCardData={lpData}
                  heading={"Learning Paths"}
                  subHeading={`👍🏻100+ learners have found these useful`}
                  viewAllAction={"/learn/courses?tab=3"}
                  type={"lp"}
                />
              ) : (
                "No LP found"
              )
            ) : (
              ""
            )}

            {partnersAvailable ? (
              partnersData.length > 0 ? (
                <CommonComponentEntity
                  newCardData={partnersData}
                  heading={"Learning Partners"}
                  subHeading={`👍🏻100+ learners have found these useful`}
                  viewAllAction={"/our-partners"}
                  type={"partner"}
                />
              ) : (
                "No Learning Partners found"
              )
            ) : (
              ""
            )}

            {videoAvailable ? (
              videosData.length === 0 ? (
                "No Video Found"
              ) : (
                <CommonComponentEntity
                  newCardData={videosData}
                  heading={"Videos"}
                  subHeading={`👍🏻100+ learners have found these useful`}
                  viewAllAction={"/learn/videos"}
                  type={"video"}
                />
              )
            ) : (
              ""
            )}

            {eventAvailable ? (
              eventsData.length > 0 ? (
                <CommonComponentEntity
                  newCardData={eventsData}
                  heading={"Events"}
                  subHeading={`👍🏻100+ learners have found these useful`}
                  viewAllAction={"/learn/events"}
                  type={"event"}
                />
              ) : (
                "No events found."
              )
            ) : (
              ""
            )}

            {certifyAvailable ? (
              certificatesData.length > 0 ? (
                <CommonComponentEntity
                  newCardData={certificatesData}
                  heading={"Certificates"}
                  subHeading={`👍🏻100+ learners have found these useful`}
                  viewAllAction={"/learn/certifications"}
                  type={"certificate"}
                />
              ) : (
                "No Certifications found"
              )
            ) : (
              ""
            )}

            {coachingAvailable ? (
              coachingsData.length > 0 ? (
                <CommonComponentEntity
                  newCardData={coachingsData}
                  heading={"Services"}
                  subHeading={`👍🏻100+ learners have found these useful`}
                  viewAllAction={"/learn/coaching"}
                  type={"coaching"}
                />
              ) : (
                "No Coachings found"
              )
            ) : (
              ""
            )}
          </div>
        )}
      </section>
    </>
  );
};

export default SearchSection;
